export default "__VITE_ASSET__CKlqc_8r__"